import { Box, Stack } from "@mui/material";
import React, { useState } from "react";

import { AccountInfoTooltip } from "components/account/AccountInfo";
import { CustomSwitch } from "components/common/CustomSwitch";
import { ConfirmDeleteModal } from "new-components/modals/ConfirmDeleteModal";
import { Typography } from "new-components/typography/Typography";
import { Detector } from "types/detectors";

interface DetectorControlsProps {
  cloudLabelingValue: "STANDARD" | "NO_HUMAN_LABELING";
  updateDetector: (
    routeOrBody?: object | BodyInit | undefined,
    body?: object | BodyInit | undefined
  ) => Promise<Detector>;
  refetchData: (route?: string | undefined) => Promise<Detector>;
}

export function DetectorControls(props: DetectorControlsProps) {
  const { cloudLabelingValue, updateDetector, refetchData } = props;

  const [openModal, setOpenModal] = useState<boolean>(false);
  const [cloudStatusValue, setCloudStatusValue] = useState<String>(cloudLabelingValue);

  const handleChangeStatus = async (value: string) => {
    setCloudStatusValue(value);
    await updateDetector({
      escalation_type: value,
    });
    refetchData();
  };

  const handleConfirm = () => {
    handleChangeStatus("NO_HUMAN_LABELING");
    setOpenModal(false);
  };

  const handleOpenModal = () => {
    setOpenModal(true);
  };

  const detectorControlsTitleStyle = {
    textTransform: "uppercase",
    fontWeight: "bold",
    letterSpacing: "-0.5px",
    color: "#49494D",
  };

  return (
    <>
      <Stack sx={{ gap: "34px" }}>
        <Typography sx={detectorControlsTitleStyle}>Detector controls:</Typography>
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <Typography sx={detectorControlsTitleStyle}>Cloud Labeling active:</Typography>
          <CustomSwitch
            checked={cloudStatusValue === "STANDARD"}
            onChange={(e) => {
              const value = e.target.checked ? "STANDARD" : "NO_HUMAN_LABELING";
              if (value === "STANDARD") {
                handleChangeStatus(value);
                return;
              }
              handleOpenModal();
            }}
            inputProps={{ "aria-label": "controlled" }}
          />
        </Box>
        <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <Typography sx={[detectorControlsTitleStyle, { minWidth: "161px" }]}>labeling resources:</Typography>
          <Typography
            style={{
              color: "#919599",
              textTransform: "none",
              fontWeight: "normal",
              fontSize: "18px",
            }}
            noWrap
          >
            Groundlight&apos;s standard labeling resources AND user-provided labeling resources.
          </Typography>
          <AccountInfoTooltip />
        </Box>
      </Stack>
      <ConfirmDeleteModal
        isDeleteModalOpen={openModal}
        setIsDeleteModalOpen={setOpenModal}
        modalTitle="Cloud Labeling Active"
        modalContent="When disabled, it is possible to label your own image queries, but they will not be escalated to Groundlight cloud labelers."
        onRemoveHandler={handleConfirm}
      />
    </>
  );
}
